<template>
  <div class="Dashboard">
    <div class="page-title">{{title}}</div>

    <el-container>
      <el-header height="40px" class="flex">
        <div class="flex-fixed" style="width: 100px;">
          <el-checkbox
            v-model="checkAll"
            :indeterminate="isIndeterminate"            
            @change="handleCheckAllChange"
          >전체보기</el-checkbox>
        </div>
        <div class="flex-auto">
          <el-checkbox-group 
            v-model="checkedCategories" 
            @change="handleCheckedCitiesChange">
            <el-checkbox
              v-for="category in categories"
              :label="category.key"
              :key="category.key"
            >{{category.value}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-header>
      <el-container>
        <el-main class="p-0">
          <el-calendar ref="calendar" v-model="value" :first-day-of-week="7" @input="handleInput">
            <!-- <template slot="dateCell" slot-scope="{date, data}"> -->
              <template slot="dateCell" slot-scope="{data}">
              <div style="height: 100%">
                <div class="calendar-day">{{ data.day.split('-').slice(2).join('-') }}</div>
                <el-tooltip effect="dark" placement="top" v-if="getDaySummary(data.day) !== null">
                  <div slot="content" style="white-space: pre-line">{{getDaySummary(data.day)}}</div>
                  <div
                    style="white-space: pre-line; height: calc(100% - 19px); overflow-y: auto"
                  >{{getDaySummary(data.day)}}</div>
                </el-tooltip>
              </div>
            </template>
          </el-calendar>          
          <div style="width:calc(100% - 40px);margin-left:20px;margin-top:-20px;">
            <ATable
              ref="table"
              max-height="80px"
              :data="total_price_list"
              hideTopPanel
              hide-button-insert
              hide-pagination
              border
            >
              <el-table-column
                prop="total_name"
                label="구분"
                :width="100"
                header-align="center"
                align="right"
              />
              <el-table-column 
                prop="sale_total" 
                label="매출액" 
                v-if="checkedCategories.find(item => item === 'sale')!==undefined"
                header-align="center"
                align="right"
              />
              <el-table-column 
                prop="collect_total" 
                label="수금실적" 
                v-if="checkedCategories.find(item => item === 'collect')!==undefined"
                header-align="center"
                align="right"
              />
              <el-table-column 
                prop="expense_total" 
                label="매입액" 
                v-if="checkedCategories.find(item => item === 'expense')!==undefined"
                header-align="center"
                align="right"
              />
              <el-table-column 
                prop="pay_total" 
                label="결제액" 
                v-if="checkedCategories.find(item => item === 'pay')!==undefined"
                header-align="center"
                align="right"
              />
            </ATable>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  data() {
    return {
      title: this.$t("title.dashboard"),
      checkAll: true,
      isIndeterminate: false,
      checkedCategories: [
        "estimation",
        "production",
        "service",
        "contract",
        "sale",
        "collect",
        "expense",
        "pay",
      ],      
      curMonthDatePrefix: null,
      value: new Date(),
      items: {},
      details: {},
      activeNames: [],
      user_data: {},
      total_price_list: [],      
    };
  },
  mounted() {        
    this.$nextTick(() => {      
      this.loadData();
      this.loadDetail();
    });
  },
  beforeDestroy() {        
    this.saveDashboardCategories();
  },
  computed: {    
    ...mapGetters(["userData", "table_user_group", "table_user_authority"]),
    categories: function() {       
      let user_group_id = this.userData.user_group_id;
      let table_user_group = this.table_user_group;
      let table_user_authority = this.table_user_authority;      
      let user_categorie_list = [];
      // 상위 메뉴들을 가져옴
      let root_auth_items = table_user_authority.filter(
        item => item.parent_id === null
      );
      let user_group = table_user_group.find(item => item.id === user_group_id);      
      if (user_group === undefined) return user_categorie_list;
      if (user_group.super_group_tag === 'Y') {
        root_auth_items.forEach( item => {
          user_categorie_list.push(item.name);
        });
      } else {                
        // 상위 메뉴를 기준으로 하위 메뉴들의 level 값을 확인하여 category 목록을 생성
        root_auth_items.forEach( item => { 
          // 현재 사용자 계정이 속한 그룹 권한 정보에서 존재하는 상위 메뉴를 검색
          let root_auth_item = user_group.authorities.find( 
            findItem => findItem.user_authority_id === item.id 
          );
          if (root_auth_item) {
            // 하위 메뉴들을 가져옴
            let child_auth_items = table_user_authority.filter(
              child_item => child_item.parent_id === root_auth_item.user_authority_id
            ); 
            // 하위 메뉴들의 level 값이 모두 '0' 이면, 상위 메뉴를 disable
            // 하위 메뉴 중 하나라도 level 값이 '1' 이상이면 상위 메뉴를 enable
            let ret_value = false;
            for ( var j = 0; j < child_auth_items.length; j++ ) {
              let auth_item = user_group.authorities.find(
                findItem => findItem.user_authority_id === child_auth_items[j].id
              );
              if (auth_item !== undefined && auth_item.level !== 0) {
                ret_value = true; 
                break;
              }
            }
            if (ret_value) user_categorie_list.push(item.name); 
          } 
        });
      }       
      return this.getCategoryList(user_categorie_list);
    },
  },
  methods: {
    handleCheckAllChange() {
      if (this.checkAll) {
        this.checkedCategories = this.categories.map(item => item.key);
      } else {
        this.checkedCategories = [];
      }
    },
    handleCheckedCitiesChange(value) {            
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.categories.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.categories.length;
      this.configureTotalPrice(value);
      this.saveDashboardCategories();
    },
    getCategoryList(list) {
      // user가 가지는 권한 이름 목록 정보를 대시보드에 표시할 카테고리 정보와 매칭시킴
      let categorie_list = [];
      list.forEach( function(item) {
        switch(item) {
          case "contract":
            categorie_list.push( { key: "contract", value: "수주건수" } );
            categorie_list.push( { key: "estimation", value: "견적건수" } );
            break;
          case "production":
            categorie_list.push( { key: "production", value: "생산실적" } );
            break;
          case "sale":
            categorie_list.push( { key: "sale", value: "매출액" } );
            categorie_list.push( { key: "collect", value: "수금실적" });
            break;
          case "buy":
            categorie_list.push( { key: "expense", value: "매입액" } );
            categorie_list.push( { key: "pay", value: "결제액" } );
            break;
          case "schedule":
            categorie_list.push( { key: "service", value: "A/S건수" } );
            break;
        }
      });
      if (this.checkedCategories.length === 0) {
        this.checkedCategories = categorie_list.map(item => item.key);
      }
      return categorie_list;
    },
    getCurrentDay() {
      return moment(this.value).format("MM월 DD일");
    },
    loadData() {
      if (this.curMonthDatePrefix === this.$refs.calendar.curMonthDatePrefix) {
        return;
      }
      let moment_ = moment(this.value);
      let startDate = moment_.startOf("month").format("YYYY-MM-DD");
      let endDate = moment_.endOf("month").format("YYYY-MM-DD");
      let params = { startDate: startDate, endDate: endDate };
      let categories_key_list = this.categories.map(item => item.key);
      if( categories_key_list.length == 0) {
        categories_key_list = this.checkedCategories;
      }      
      this.api.listUserConfig(this.userData.id).then(res => {
          if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }         
        this.user_data = res.data;
        this.getDashboardData();
      });      
      this.api.listSchedule(params, categories_key_list).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res;
        this.configureTotalPrice();
      });
      this.curMonthDatePrefix = this.$refs.calendar.curMonthDatePrefix;
    },
    getDashboardData() {
      let dashboard_list = [];
      // config 컬럼에 데이터가 없는 경우
      if (!this.user_data.config) {
        this.user_data.config = {};
        this.user_data.config.dashboard = {};
        this.checkedCategories.forEach( item => {
          this.user_data.config.dashboard[item] = 'N';
        });
      // config 컬럼에 데이터는 있지만, dashboard 데이터가 없는 경우
      } else if (!this.user_data.config.dashboard) {
        this.user_data.config.dashboard = {};
        this.checkedCategories.forEach( item => {
          this.user_data.config.dashboard[item] = 'N';
        });
      // config 컬럼에 dashboard 데이터가 있는 경우
      } else {
        this.checkedCategories.forEach( item => {
          if (this.user_data.config.dashboard[item] === 'Y') {
            dashboard_list.push(item);
          }
        });
      }
      this.checkedCategories = dashboard_list;
    },
    saveDashboardCategories() {
      // 선택된 카테고리 정보를 config 컬럼의 dashboard 데이터에 JSON 형태로 저장
      if (this.categories.length === this.checkedCategories.length) {
        this.checkedCategories.forEach( item => {
          this.user_data.config.dashboard[item] = 'Y';
        });      
      } else {
        this.categories.forEach( item => {        
          let checkedItem = this.checkedCategories.find(findItem => findItem === item.key);        
          if (checkedItem === undefined) this.user_data.config.dashboard[item.key] = 'N';
          else this.user_data.config.dashboard[checkedItem] = 'Y';
        });
      }
      this.api.updateUser(this.user_data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }      
      });
    },
    /**
     * 각 매출액 / 수금실적 / 매입액 / 결제액의 월 누계 & 연 누계 값을 계산
     */
    configureTotalPrice() {
      this.total_price_list = [];
      let month_total_price = {};      
      let year_total_price = {};
      month_total_price.total_name = "월 누계";
      year_total_price.total_name = "연 누계";
      // 매출액
      if (this.checkedCategories.find(item => item === "sale") !== undefined) {
        let sale_month_price = 0;
        if (this.items.sale !== undefined) {
          this.items.sale.forEach( item => {
            sale_month_price += Number(item.data);
          });
          month_total_price.sale_total = this.numberWithCommas(sale_month_price) + "원";
        }
        if (this.items.sale_year[0].year_price !== null) {
          year_total_price.sale_total = this.numberWithCommas(this.items.sale_year[0].year_price) + "원";
        } else {
          year_total_price.sale_total = "0원";
        }
      }
      // 수금실적
      if (this.checkedCategories.find(item => item === "collect")!== undefined) {
        if (this.items.collect !== undefined) {
          let collect_month_price = 0;
          this.items.collect.forEach( item => {
            collect_month_price += Number(item.data);
          });
          month_total_price.collect_total = this.numberWithCommas(collect_month_price) + "원";
        }
        if (this.items.collect_year[0].year_price !== null ) {
          year_total_price.collect_total = this.numberWithCommas(this.items.collect_year[0].year_price) + "원";
        } else {
          year_total_price.collect_total = "0원";
        }
      }
      // 매입액
      if (this.checkedCategories.find(item => item === "expense") !== undefined) {
        if (this.items.expense !== undefined) {
            let expense_month_price = 0;
          this.items.expense.forEach( item => {
            expense_month_price += Number(item.data);
          });
          month_total_price.expense_total = this.numberWithCommas(expense_month_price) + "원";
        }
        if (this.items.expense_year[0].year_price !== null) {
          year_total_price.expense_total = this.numberWithCommas(this.items.expense_year[0].year_price) + "원";
        } else {
          year_total_price.expense_total = "0원";
        }
      }
      // 결제액
      if (this.checkedCategories.find(item => item === "pay") !== undefined) {
        if (this.items.pay !== undefined) {
          let pay_month_price = 0;
          this.items.pay.forEach( item => {
            pay_month_price += Number(item.data);
          });
          month_total_price.pay_total = this.numberWithCommas(pay_month_price) + "원";
        }
        if (this.items.pay_year[0].year_price !== null) {
          year_total_price.pay_total = this.numberWithCommas(this.items.pay_year[0].year_price) + "원";
        } else {
          year_total_price.pay_total = "0원";
        }
      }
      this.total_price_list.push(month_total_price);
      this.total_price_list.push(year_total_price);
    },
    getDaySummary(day) {
      let content = null;
      if (day) {
        this.checkedCategories.forEach(key => {
          if (!key) { return true; }
          let category = this.categories.find(item => item.key === key);
          if( category != undefined ) {
            let name = category.value;
            let data = this.items[key];
            if (data) {
              data = data.filter(item => item.date === day);
              let length = data.length;
              if (length > 0) {
                if (content == null) content = "";
                let val = 0;
                data.forEach(d => {
                  val += d.data;
                });
                content += name + " " + this.numberWithCommas(val);
                switch (category.key) {
                  case "collect":
                  case "collect_service":
                  case "sale":
                  case "pay":
                  case "expense":
                  case "uncollected_service":
                    content += "원\n";
                    break;
                  default:
                    content += "건\n";
                    break;
                }
              }
            }
          }
        });
      }
      return content;
    },
    loadDetail() {
      // let date = this.util.getDateString(this.value);
      // this.api.listScheduleDetail(date).then(res => {
      //   if (res.error !== this.system.noError) {
      //     this.util.notify_error(this, "대쉬보드", res.message);
      //     return;
      //   }
      //   this.details = res;
      // });
    },
    getCategoryName(key) {
      let category = this.categories.find(category => category.key === key);
      return category ? category.value : null;
    },
    getCategoryCount(key) {
      if (this.details) {
        let data = this.details[key];
        return data ? data.length : 0;
      }
      return 0;
    },
    getCategoryTotalPrice(key) {
      if (this.details) {
        let data = this.details[key];
        if (data) {
          let totalPrice = data.reduce(
            (a, b) => a + (b.price ? b.price : 0),
            0
          );
          return totalPrice;
        }
      }
      return 0;
    },
    handleInput(/*val*/) {
      this.$nextTick(() => {
        this.loadData();
        this.loadDetail();
      });
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getCategories() {
      let ret = [];
      this.checkedCategories.forEach(c => {
        if (this.getCategoryCount(c) > 0) {
          ret.push(c);
        }
      });
      return ret;
    }
  }
};
</script>

<style lang="scss">
.Dashboard {
  .el-calendar {
    font-size: 13px;;
  }
  .el-calendar-table td {
    height: 100px;
  }
  .left-space {
    margin-left: 20px;
  }
  .top-space-reverse {
    margin-top: -15px;
  }
  .top-space {
    margin-top: 10px;
  }
}
</style>
